/**
 * Header behaviour: scroll shadow, Shop dropdown, burger menu, mini-cart.
 *
 * This used to be ~11 KB of inline <script> in sections/pc-header.liquid, i.e. 11 KB added
 * to the HTML of EVERY page, re-sent on every navigation and parsed mid-body where it
 * blocked the parser. As a deferred asset it is cached once and runs after parse.
 *
 * Liquid values arrive via window.PCHeader (set inline just before this loads), because a
 * .js asset is not rendered through Liquid.
 */
var PC = window.PCHeader || { money: '${{amount}}', cartUrl: '/cart', cartChangeUrl: '/cart/change' };
// Pieces per pack by product id (Flavor Press / Grinder King sell as twin packs): − / + move a whole pack.
function packOf(productId) { return (PC.packs && PC.packs[productId]) || 1; }

(function () {
  // Sticky positioning lives in CSS (the section wrapper carries "pc-header-section" via
  // this section's schema `class`). It used to be three inline style writes here followed
  // by a window.scrollY read in the same task, which forces a synchronous layout —
  // PageSpeed attributed 49 ms of forced reflow to that one line.
  //
  // The scroll shadow reads no layout either: an absolutely-positioned 8px sentinel sits at
  // the top of the document, and the header is "scrolled" exactly when the sentinel is out
  // of view. scrollY would force a layout flush every time it is read while styles are
  // dirty; IntersectionObserver reports asynchronously and never does.
  var hdr = document.querySelector('.pc-header');
  var wrap = hdr && hdr.closest('.pc-header-section');
  if (hdr && wrap && wrap.parentNode && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    // display:block is load-bearing: base.css has `div:empty{display:none}`, which gave this
    // empty sentinel a 0x0 box, so IntersectionObserver reported it as never intersecting and
    // the shadow stuck on at scroll 0. An inline style outranks that rule.
    sentinel.style.cssText = 'display:block;position:absolute;top:0;left:0;width:1px;height:8px;pointer-events:none;opacity:0';
    wrap.parentNode.insertBefore(sentinel, wrap);
    new IntersectionObserver(function (entries) {
      hdr.classList.toggle('pc-header--scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  } else if (hdr) {
    var onScroll = function () { hdr.classList.toggle('pc-header--scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
(function () {
  // Shop dropdown. The <a> is left alone so it always navigates; only the chevron toggles.
  var grp = document.querySelector('[data-pc-navgrp]');
  if (!grp) return;
  var tog = grp.querySelector('.pc-navtog');
  var panel = grp.querySelector('.pc-navpanel');
  if (!tog || !panel) return;

  var hoverOK = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var closeTimer = null;
  // Hover and click would otherwise fight: hovering opens the panel, so a click on the
  // chevron would read as "already open -> close" and the control would look broken.
  // A click therefore PINS the panel; only a pinned panel survives mouseleave.
  var pinned = false;

  function setOpen(open) {
    panel.hidden = !open;
    tog.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function isOpen() { return tog.getAttribute('aria-expanded') === 'true'; }
  function open() { clearTimeout(closeTimer); setOpen(true); }
  function close() { clearTimeout(closeTimer); pinned = false; setOpen(false); }

  tog.addEventListener('click', function () {
    if (pinned) { close(); } else { pinned = true; open(); }
  });

  // Hover is an enhancement on pointer devices only — never the sole way in.
  if (hoverOK) {
    grp.addEventListener('mouseenter', function () { clearTimeout(closeTimer); if (!isOpen()) setOpen(true); });
    grp.addEventListener('mouseleave', function () {
      if (pinned) return;
      closeTimer = setTimeout(function () { setOpen(false); }, 120); // grace crossing the gap
    });
  }

  grp.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { close(); tog.focus(); }
  });
  // Tabbing out of the group closes it; clicking outside does too.
  grp.addEventListener('focusout', function (e) {
    if (!grp.contains(e.relatedTarget)) close();
  });
  document.addEventListener('click', function (e) {
    if (isOpen() && !grp.contains(e.target)) close();
  });
})();
(function () {
  // "Buy Now" — if we're already on the button's target product page, don't navigate:
  // just scroll up to the main buy box. Any bundle/kit/sticker selection is KEPT.
  var btn = document.querySelector('[data-pc-buynow]');
  if (!btn) return;
  btn.addEventListener('click', function (e) {
    var href = btn.getAttribute('href') || '';
    var targetPath = href.split('#')[0].split('?')[0].replace(/\/$/, '');
    var here = window.location.pathname.replace(/\/$/, '');
    if (!targetPath || here !== targetPath) return; // different page → navigate normally
    e.preventDefault();
    var buy = document.getElementById('buy') || document.getElementById('top');
    if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
(function () {
  var root = document.getElementById('pc-mc');
  var body = document.getElementById('pc-mc-body');
  var foot = document.getElementById('pc-mc-foot');
  var subEl = document.getElementById('pc-mc-subtotal');
  var countEl = document.getElementById('pc-cart-count');
  if (!root) return;
  var panel = root.querySelector('.pc-mc__panel');
  var closeBtn = document.getElementById('pc-mc-close');
  var statusEl = document.getElementById('pc-mc-status');

  function money(cents) {
    return PC.money.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }
  // Titles are merchant-controlled but go through innerHTML — escape them.
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function say(msg) { if (statusEl) statusEl.textContent = msg; }
  var pendingNote = null;
  function setCount(n) {
    if (!countEl) return;
    countEl.textContent = n;
    countEl.classList.toggle('is-empty', n === 0);
  }
  function render(cart) {
    setCount(cart.item_count);
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="pc-mc__empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    var html = '';
    // One-off confirmation from an add-to-cart (PCMiniCart.open(trigger, note)); cleared after one render.
    if (pendingNote) {
      html += '<p class="pc-mc__added"><span aria-hidden="true">&#10003;</span> ' + esc(pendingNote) + '</p>';
      say(pendingNote + '. ' + cart.item_count + ' items in your cart.');
      pendingNote = null;
    }
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
      var step = packOf(it.product_id);
      html += '<div class="pc-mc__item" data-key="' + it.key + '" data-step="' + step + '">'
        + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div style="width:64px"></div>')
        + '<div class="pc-mc__info">'
        + '<p class="pc-mc__name">' + esc(it.product_title) + '</p>'
        + (it.variant_title ? '<p class="pc-mc__meta">' + esc(it.variant_title) + '</p>' : '')
        + (it.properties && it.properties['Ships'] ? '<p class="pc-mc__meta">Ships ' + esc(it.properties['Ships']) + '</p>' : '')
        + (it.properties && it.properties['Ships by'] ? '<p class="pc-mc__meta">Ships by ' + esc(it.properties['Ships by']) + '</p>' : '')
        + '<div class="pc-mc__qty">'
        + '<button class="pc-mc__qbtn" data-act="dec" aria-label="' + (it.quantity <= step ? 'Remove ' : 'Decrease quantity of ') + esc(it.product_title) + '">&minus;</button>'
        + '<span class="pc-mc__qval">' + it.quantity + '</span>'
        + '<button class="pc-mc__qbtn" data-act="inc" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button>'
        + '</div></div>'
        + '<div class="pc-mc__price">' + money(it.final_line_price) + '</div>'
        + '</div>';
    });
    body.innerHTML = html;
    subEl.textContent = money(cart.total_price);
    foot.hidden = false;
  }
  function load() {
    body.innerHTML = '<p class="pc-mc__empty">Loading…</p>';
    fetch(PC.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { body.innerHTML = '<p class="pc-mc__empty">Could not load cart.</p>'; });
  }
  // One request at a time: rapid +/- clicks would otherwise race and the last
  // response — not the last click — would win.
  var busy = false;
  function change(key, qty) {
    if (busy) return;
    busy = true;
    body.setAttribute('aria-busy', 'true');
    setDisabled(true);
    fetch(PC.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed: ' + r.status);
        return r.json();
      })
      .then(function (cart) { render(cart); say('Cart updated. ' + cart.item_count + ' items.'); })
      .catch(function () {
        var p = document.createElement('p');
        p.className = 'pc-mc__err';
        p.textContent = 'Could not update that. Check your connection and try again.';
        body.appendChild(p);
        say('Could not update the cart.');
        setDisabled(false);
      })
      .then(function () { busy = false; body.removeAttribute('aria-busy'); });
  }
  function setDisabled(state) {
    body.querySelectorAll('.pc-mc__qbtn').forEach(function (b) { b.disabled = state; });
  }

  // Focus management: aria-modal is a promise the drawer has to keep.
  var lastFocused = null;
  var FOCUSABLE = 'button:not(:disabled), a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function trap(e) {
    if (e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { close(); return; }
    trap(e);
  }
  function open(e) {
    // Capture the trigger from the event, not document.activeElement: Safari does not
    // focus a <button> on click, so activeElement would be <body> and focus would be lost.
    lastFocused = (e && e.currentTarget) || document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    var tg = document.getElementById('pc-cart-toggle'); if (tg) tg.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    load();
    closeBtn.focus();
  }
  function close() {
    root.setAttribute('aria-hidden', 'true');
    var tg2 = document.getElementById('pc-cart-toggle'); if (tg2) tg2.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    else { var t = document.getElementById('pc-cart-toggle'); if (t) t.focus(); }
    lastFocused = null;
  }

  document.getElementById('pc-cart-toggle').addEventListener('click', open);
  // Lets a product page open the drawer after its own add-to-cart; focus returns to `trigger` on close.
  window.PCMiniCart = {
    open: function (trigger, note) { pendingNote = note || null; open({ currentTarget: trigger }); }
  };
  closeBtn.addEventListener('click', close);
  document.getElementById('pc-mc-scrim').addEventListener('click', close);

  body.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc-mc__qbtn');
    if (!btn) return;
    var row = btn.closest('.pc-mc__item');
    var key = row.getAttribute('data-key');
    var cur = parseInt(row.querySelector('.pc-mc__qty span').textContent, 10);
    var step = parseInt(row.getAttribute('data-step'), 10) || 1;
    // Snap to whole packs, so a stray odd count (e.g. an old cart) lands on 2, 4, 6 … or 0.
    change(key, btn.getAttribute('data-act') === 'inc' ? (Math.floor(cur / step) + 1) * step : (Math.ceil(cur / step) - 1) * step);
  });

  // Refresh count on show (bfcache) and after add-to-cart events elsewhere
  window.addEventListener('pageshow', function () {
    fetch(PC.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
  });
})();

/* Burger: a plain <details> doesn't close on Esc or on a tap outside — add both (focus returns to the toggle on Esc). */
(function () {
  var d = document.querySelector('.pc-burger');
  if (!d) return;
  var sum = d.querySelector('summary');
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && d.open) { d.open = false; if (sum) sum.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (d.open && !d.contains(e.target)) d.open = false;
  });
})();
